import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  message: string;
  id: number;
  confirmMessage:string;
}

@Component({
  selector: 'dialog-overview-example-dialog',
  template:
    '<h1 mat-dialog-title>Confirm</h1>' +
    "<div mat-dialog-content>" +
    "<p>{{data.message}}</p>" +
    '</div>' +
    '<div mat-dialog-actions>' +
    '<button mat-button (click)="onNoClick()" cdkFocusInitial>No Thanks</button>' +
    '<button mat-button (click)="onOkClick()">Ok</button>' +
    '</div>',
})
export class ConfirmDialog {

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.data.confirmMessage = "NO";
    this.dialogRef.close(this.data);
  }
  onOkClick(): void{
    console.log(this.data);
    this.data.confirmMessage = "YES";
    this.dialogRef.close(this.data);
  }
}